<template>
    <!-- visible -->
    <div class="pagex">
        <!-- <van-popup :class="position == 'right' ? 'one' : 'onePc'" v-model="visible" :position="position == 'right' ? 'right' : 'center'"> -->
        <div class="one_body" v-if="!isWpage">
            <div v-if="page == 'index'">
                <img class="imge" src="../../../assets/image/one/logo.png" alt="">
                <div class="title flex">
                    <div class="title_t">
                        <span>{{ $t('new14') }}</span>
                        <div></div>
                    </div>
                    <!-- <div class="title_x" @click="onVisible">
                        <svg t="1732585927904" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="6277"
                            data-spm-anchor-id="a313x.search_index.0.i8.51fd3a819BMxuG" width="200" height="200">
                            <path
                                d="M512 128c211.2 0 384 172.8 384 384s-172.8 384-384 384-384-172.8-384-384 172.8-384 384-384m0-64C262.4 64 64 262.4 64 512s198.4 448 448 448 448-198.4 448-448-198.4-448-448-448z"
                                fill="#999999" p-id="6278" data-spm-anchor-id="a313x.search_index.0.i7.51fd3a819BMxuG"
                                class="selected"></path>
                            <path
                                d="M646.4 332.8L512 467.2 377.6 332.8c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8L467.2 512l-134.4 134.4c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l134.4 134.4c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l134.4-134.4c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0z"
                                fill="#999999" p-id="6279" data-spm-anchor-id="a313x.search_index.0.i10.51fd3a819BMxuG"
                                class="selected"></path>
                        </svg>
                    </div> -->
                </div>

                <div class="price">
                    <div class="price_title">{{ $t('yi2') }}</div>
                    <div class="price_body">
                        <div v-for="el in UsdList" :key="el" @click="onPages('des', el)">
                            <span>{{ el }}USD</span>
                            <!-- {{ $t('yi3') }} -->
                        </div>
                    </div>
                </div>

                <div class="run">
                    <!-- <div @click="onPageGo('HuntNotes')">{{ $t('yi4') }}</div> -->
                    <div @click="onPagesWon('hunt_notes')">{{ $t('yi4') }}</div>

                    <div @click="onPages('notes')">{{ $t('yi5') }}</div>

                    <!-- position -->
                    <!-- <div @click="onPagesWon('hunt_cashNew')">{{ $t('yi6') }}</div> -->
                    <!-- <div @click="onPagesWon('hunt_cashNew')" v-if="position == 'right'">{{ $t('yi6') }}</div> -->
                    <!-- <div @click="onPageGo('HuntIndex')">{{ $t('new25') }}</div> -->
                    <div @click="onPagesWon('withdraw_list')">{{ $t('yi7') }}</div>
                    <div @click="onPagesWon('recharge_list')">{{ $t('yi8') }}</div>
                    <!-- <div @click="onPagesWon('convert')">{{ $t('hunt4') }}</div> -->
                    <div @click="onPagesWon('commission')">{{ $t('MyCommission') }}</div>
                    <div @click="onPagesWon('points')">{{ $t('Points Logs') }}</div>
                    <div @click="onPagesWon('hunt_newRule')">{{ $t('hunt65') }}</div>
                    <div @click="onPagesWon('shipping')">{{ $t('hunt17') }}</div>
                    <div @click="onPagesWon('my_team')">{{ $t('MyTeam') }}</div>
                </div>
            </div>
            <!--  -->
            <Des @onPage="onGoto" :val="usd" v-if="page == 'des'"  ref="RefDes" />
            <!--  -->
            <BuyDes @onPage="onGoto" :val="usd" v-if="page == 'buyDes'" />
            <!--  -->
            <GdsDes @onPage="onGoto" :val="usd" :objData="objData" ref="RefGdsDes" v-if="page == 'gdsDes'" />
            <!--  -->
            <Notes @onPage="onGoto" @onPagesWon="onPagesWon" @onPageData="onPageData" :val="usd" v-if="page == 'notes'" />
        </div>

        <div class="one_body pagePc" v-else>
            <!-- 夺宝记录 -->
            <HuntNotes @onPage="onGoto" :one="true" v-if="page == 'hunt_notes'" />
            <!-- 查看兑换码 -->
            <HuntCashNew @onPage="onGoto" :one="true" :objData="objData" v-if="page == 'hunt_cashNew'" />
            <!-- 规则 -->
            <HuntNewRule @onPage="onGoto" :one="true" v-if="page == 'hunt_newRule'" />
            <!-- 提现 -->
            <MemberWithdrawList @onPage="onGoto" :one="true" v-if="page == 'withdraw_list'" />
            <!-- 充值 -->
            <RechargeList @onPage="onGoto" :one="true" v-if="page == 'recharge_list'" />
            <!-- 寄货规则 -->
            <Shipping  @onPage="onGoto" :one="true" v-if="page == 'shipping'" />
            <!-- 我要兑换 -->
            <Convert @onPage="onGoto" :one="true" :objData="slayDate" v-if="page == 'convert'" />
            <!-- 我的佣金 -->
            <Commission @onPage="onGoto" :one="true" v-if="page == 'commission'" />
            <!-- 我的积分 -->
            <Points @onPage="onGoto" :one="true" v-if="page == 'points'" />
            <!-- 收货 -->
            <Pickup @onPage="onGoto" :one="true" :objData="slayDate" v-if="page == 'pickup'" />
            <!-- 我的团队 -->
            <MyTeam @onPage="onGoto" :one="true" :objData="slayDate" v-if="page == 'my_team'" />
        </div>
        <buyDialog :show="showModal" @updateShow="updateShow" @onPagesWon="onPagesWon" :objData="slayDate" :BuyType="false" :isWin="isWin"
            @onPage="onGoto" />
        <!-- </van-popup> -->
    </div>
</template>

<script>
import Des from './des.vue'
import BuyDes from './buyDes.vue'
import GdsDes from './gdsDes.vue'
import BuyDialog from './buyDialog.vue'
import Notes from './notes.vue'
import HuntNotes from '../hunt/notes.vue'
import HuntCashNew from '../hunt/cashNew.vue'
import HuntNewRule from '../hunt/newRule.vue'
import MemberWithdrawList from './WithdrawList.vue'
import RechargeList from './RechargeList'
import Shipping from '../hunt/shipping.vue'
import Convert from '../hunt/convert.vue'
import Commission from '../one/Commission.vue'
import Points from '../point/PointList.vue'
import Pickup from './Pickup.vue'
import MyTeam from './MyTeam.vue'

import { vitiList, GetLatestLotteryInfo, GetCycleList } from '../../../api/memberOne'
import store from "../../../store";
var ws;
export default {
    name: 'Hunt',
    props: {
        visible: {
            default: false,
            type: Boolean
        },
        position: {
            default: 'right',
            type: String
        }
    },
    components: {
        Des,
        BuyDes,
        GdsDes,
        BuyDialog,
        Notes,
        HuntNotes,
        HuntCashNew,
        HuntNewRule,
        MemberWithdrawList,
        RechargeList,
        Shipping,
        Convert,
        Points,
        Commission,
        Pickup,
        MyTeam
    },
    data() {
        return {
            isShow: this.visible,
            page: 'index',
            UsdList: [],
            val: '',
            objData: {},
            slayDate: {},
            usd: '',
            showModal: false,
            member_id: '',
            isWin: true,
            isWpage: false,
            isX: true
        }
    },
    watch: {
        $route(to, from) {}
    },
    created() {
        this.getUsdList()
        this.createWebSocket();
    },
    mounted() {},
    beforeDestroy() {
        if (this.socket) {
            this.socket.close(); // 关闭 WebSocket 连接
            this.socket = null;
        }
    },
    methods: {
        createWebSocket() {
            // 检查 WebSocket 是否已连接
            if (this.socket_connect === 1) {
                console.log("WebSocket 已连接，跳过创建");
                return;
            }

            const currentDomain = window.location.origin;
            let ws_url = currentDomain.includes('goshop.shop') ? env.WS_URL : env.WS_URL1;
            try {
                ws = new WebSocket(ws_url);
                this.init();
            } catch (e) {
                this.reconnect();
            }
        },
        init() {
            ws.onopen = this.wsOpen;
            ws.onmessage = this.wsMessage;
            ws.onclose = this.wsClose;
            ws.onerror = this.wsError;
        },
        wsOpen() {
            //请求参数
            var param = {
                type: "login",
                activity_type: "luckbuy",
                key: store.state.member.token,
                member_id:store.state.member.info.member_id
            };
            // 使用 send() 方法发送数据
            ws.send(JSON.stringify(param));
            this.socket_connect = 1;
            // 心跳检测重置
            heartCheck.start();
        },
        wsMessage(res) {
            if(res.data == 'pong') return;
            let res_ = JSON.parse(res.data);
            let data = res_.data;
            if(data.type == 'box_now_info') return;
            if(this.showModal) return;
            if (this.isObjectWithUid(res_)){
                //如果类型为幸运购开奖
                if (data.type == 'luck_buy_draw') {
                    //更新活动列表
                    if(this.page == 'des' ){
                        this.callChildMethod('RefDes', 'getUsdActivityList', 1)
                    }
                    //更新活动详情
                    if(this.page == 'gdsDes'){
                        this.callChildMethod('RefGdsDes', 'onGetActivityInfo', 1)
                    }
                    //开奖
                    this.onGetLatestLotteryInfo()
                }
                //如果类型为幸运购下单,更新已购买数量
                if (data.type === 'luck_buy_order') {
                    if(this.page == 'des'){ 
                        this.callChildMethod('RefDes', 'onUpdateSlotsSold', data)
                    }
                    if(this.page == 'gdsDes'){
                        this.callChildMethod('RefGdsDes', 'onUpdateSlotsSold', data)
                    }
                }
            }
            heartCheck.start();
        },
        wsClose(res) {
            this.socket_connect = 0;
            if (res.reason) {
                console.log("断开：" + res.reason);
            }
            if (this.canReconnect) {
                this.reconnect();
            }
        },
        wsError() {
            console.log("websocket断开");
            this.reconnect();
        },
        reconnect() {
            console.log("尝试重连");
            if (this.lockReconnect) {
                return;
            }
            this.lockReconnect = true;
            // 没连接上会一直重连，设置延迟避免请求过多
            this.timeOut && clearTimeout(this.timeOut);
            var _this = this;
            this.timeOut = setTimeout(function () {
                console.log('重连中...')
                _this.createWebSocket();
                _this.lockReconnect = false;
            }, 3000);
        },
        isObjectWithUid(data) {
            // 检查 data 是否是对象并且不是 null
            if (typeof data === "object" && data !== null) {
                return true;
            }
            return false;
        },
        onVisible() {
            this.isShow = !this.isShow;
            this.$emit('onVisible', false)
        },
        getVitiList() {
            vitiList({
                price_range: '100,200',
                page: 1,
                limit: 10,
            }, 'one').then(res => {
            }, error => { })
        },
        // 获取usd列表
        getUsdList() {
            if(localStorage.getItem('usd_list')){
                this.UsdList = JSON.parse(localStorage.getItem('usd_list'))
            }else{
                GetCycleList({}, 'one').then(res => {
                    if (res && res.result) {
                        this.UsdList = res.result
                        localStorage.setItem('usd_list', JSON.stringify(res.result));
                    }
                }, error => { })
            }
        },
        onPageGo(name, val) {
            this.$router.push({ name: name, query: { data: val } })
        },
        onGoto(v, val) {
            this.isWpage = false
            if (v == 'x') {
                this.isShow = !this.isShow;
                this.$emit('onVisible', false)
                return
            }
            this.page = v
            this.objData = val || {}
        },
        onPagesWon(v, val, page = 'index') {
            this.isWpage = true
            this.page = v
            val.page = page ? page : 'index'
            this.objData = val || {}
        },
        onPageData(v, val) {
            this.isWpage = true
            this.page = v
            this.slayDate = val || {}
        },
        onPages(v, val) {
            this.isWpage = false
            this.page = v
            this.usd = val || ''
        },
        // 开奖结果
        updateShow() {
            this.showModal = false
        },
        //调用子组件的方法
        callChildMethod(ref, fun, data) {
            // 通过 this.$refs 访问子组件实例并调用其方法
            if (this.$refs[ref] && typeof this.$refs[ref][fun] === 'function') {
                this.$refs[ref][fun](data);
            }
        },
        // 开奖结果
        onGetLatestLotteryInfo() {
            if(this.showModal) return;
            GetLatestLotteryInfo({}, 'one').then(res => {
                if (res && res.result && res.result.member_id) {
                    this.slayDate = res.result
                    let data = JSON.parse(sessionStorage.getItem('actData')) || []

                    let datax = JSON.parse(localStorage.getItem('gobuy'))
                    const memberxid = datax.member.info.member_id || ''
                    if (res.result.member_id == memberxid) {
                        // 中奖
                        this.isWin = true
                        this.showModal = true
                    } else {
                        // 未中奖
                        this.isWin = false
                        this.showModal = true
                    }
                }
            })
        }
    }
}
// 心跳检测
var heartCheck = {
  timeout: 10000,
  timeoutObj: null,
  start: function () {
    this.timeoutObj && clearInterval(this.timeoutObj);
    this.timeoutObj = setInterval(function () {
        console.log(ws.readyState)
        if (ws.readyState === WebSocket.OPEN) {
            ws.send("ping");
        }
    }, this.timeout);
  },
  stop: function () {
    this.timeoutObj && clearInterval(this.timeoutObj);
  },
};
</script>

<style scoped lang="scss">
.pagex {
    width: 100%;
    height: 100%;
}

.one {
    width: 82%;
    height: 100vh;
    background: rgba(0, 0, 0, 0);
}

.onePc {
    width: 20%;
    min-width: 375px;
    height: 70vh;
    background: rgba(0, 0, 0, 0);
}


.flex {
    display: flex;
}

.pagePc {
    padding: 0 !important;
    overflow-y: hidden !important;
}

.one_body {
    overflow-y: auto;
    width: 100%;
    height: 100vh;
    background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
    border-radius: 12px;
    border: 1px solid #F45C1D;
    padding: 15px 20px;
    box-sizing: border-box;
    position: relative;

    .imge {
        position: absolute;
        left: 0;
        width: 50%;
        bottom: 10%;
        transform: translate(50%, 0%);
    }

    .title {
        align-items: center;
        justify-content: space-between;

        .title_t {
            font-size: 14px;
            color: #000;
            font-weight: bold;
            cursor: pointer;

            div {
                width: 100%;
                height: 5px;
                background: linear-gradient(90deg, #F21D19 0%, #FFF5F4 100%);
                border-radius: 8px;
            }
        }

        .title_x {
            cursor: pointer;

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }

    .price {
        margin: 50px 0 20px;
        border: #F9A07B 1px solid;
        border-radius: 10px;
        padding: 10px 5px;
        box-sizing: border-box;
        position: sticky;
        z-index: 999;

        .price_title {
            font-size: 16px;
            color: #333;
            font-weight: bold;
            padding-left: 10px;
        }

        .price_body {
            padding: 20px 0 0;
            color: #EC3031;
            font-size: 12px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);


            div {
                margin-bottom: 20px;
                text-align: center;
            }

            span {
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }

    .run {
        border: #F9A07B 1px solid;
        border-radius: 10px;
        padding: 20px 10px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
        gap: 20px;
        font-size: 12px;
        z-index: 10;
        position: sticky;

        div {
            padding: 10px 0;
            text-align: center;
            font-weight: bold;
            cursor: pointer;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            border-radius: 5px;
            border: 1px solid #F45C1D;
        }
    }
}
</style>